<template>
    <div class="c-locale">
        <button :id="btnId" class="c-locale--current" @click.prevent="toggleLocaleSelect">
        </button>
        <div class="c-locale--select" v-if="localeSelectVisible">
            <button class="c-locale--select--btn" :class="{selected : locale == $i18n.locale}"
                v-for="locale, i in locales" :key="locale" @click.prevent="setLocale(locale)">
                {{localeLabels[i]}}
            </button>
        </div>
    </div>
</template>

<script>
import localforage from "localforage";
import DocumentClickMixin from "@/mixins/DocumentClickMixin";

export default {
    name : "LocaleSelect",
    mixins: [DocumentClickMixin],
    data() {
        return {
            locales : ["benl", "nl", "fr", "en", "de", "lu"],
            localeLabels : ["be-nl", "nl-nl", "fr", "en", "de", "lu"],

            localeSelectVisible : false,
            btnId : "btn-locale-select"
        };
    },

    methods : {
        toggleLocaleSelect() {
            this.localeSelectVisible = !this.localeSelectVisible;
        },

        setLocale(lang) {
            this.$i18n.locale = lang;
            this.localeSelectVisible = false;
            localforage.setItem("locale", lang);
        },

        documentClickTriggered() { //called from mixin
            this.localeSelectVisible = false;
        },

        formatLocale(locale) {
            if (locale.length === 2) {
                return locale;
            }
            return locale.substring(0, 2) + "-" + locale.substring(2);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-locale {
        &--current {
            @extend .reset-btn;
            background-image: url('/img/locale-icon.png');
            background-repeat: no-repeat;
            background-size : 100%;
            width : 3rem;
            height : 3rem;
        }

        &--select {
            position: absolute;
            bottom : 3rem;
            left: -1.5rem;

            &--btn {
                background-color : white;
                color : $color-blue;
                text-transform: uppercase;
                font-size: 1.15em;
                padding: .5rem 0rem;
                border: none;
                width: 3.65em;
                border: solid 1px $color-blue;

                &.selected {
                    background : $color-blue;
                    color : white;
                }

            }
        }

        @include slideIntroAnimation(basicSlideIntro, 350ms, 2s);

    }
</style>